export default __webpack_public_path__ + "static/media/dot-grid.5b966bde.svg";